<script setup>
import KanbanCard from '../cards/KanbanCard.vue';

const props = defineProps({
  saturdayTasks: { type: Array, default: () => [] },
  sundayTasks: { type: Array, default: () => [] },
  saturdayDate: { type: [String, Number], required: true },
  sundayDate: { type: [String, Number], required: true },
  isSaturdayToday: { type: Boolean, default: false },
  isSundayToday: { type: Boolean, default: false }
});

const emit = defineEmits(['create-task', 'select-task', 'dragstart', 'dragover-task', 'drop-task', 'drop-column']);
</script>

<template>
  <div class="weekend-double-column">
    <div
      class="kanban-collum-half"
      :class="{ 'today-column': isSaturdayToday }"
      @dragover.prevent
      @drop="emit('drop-column', 'Sábado', 5)"
    >
      <div class="d-flex justify-content-between align-items-center w-100 mb-2 px-1">
        <div class="column-header-text">
          <span class="text-uppercase mr-1 text-secondary"><b>SAB</b></span>
          <span class="text-dark"><b>{{ saturdayDate }}</b></span>
          <span v-if="isSaturdayToday" class="text-primary-custom ml-1"><b>(hoje)</b></span>
        </div>
        <button type="button" class="btn-add-task-icon" @click="emit('create-task', 5)" title="Nova tarefa">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>

      <div class="kanban-task-list">
        <transition-group name="move" tag="div">
          <KanbanCard
            v-for="(task, tIndex) in saturdayTasks"
            :key="task.id || tIndex"
            :task="task"
            @select="emit('select-task', $event)"
            @dragstart="emit('dragstart', $event, 'Sábado')"
            @dragover="emit('dragover-task', $event)"
            @drop="emit('drop-task', $event)"
          />
        </transition-group>
      </div>
    </div>

    <div
      class="kanban-collum-half mt-2"
      :class="{ 'today-column': isSundayToday }"
      @dragover.prevent
      @drop="emit('drop-column', 'Domingo', 6)"
    >
      <div class="d-flex justify-content-between align-items-center w-100 mb-2 px-1">
        <div class="column-header-text">
          <span class="text-uppercase mr-1 text-secondary"><b>DOM</b></span>
          <span class="text-dark"><b>{{ sundayDate }}</b></span>
          <span v-if="isSundayToday" class="text-primary-custom ml-1"><b>(hoje)</b></span>
        </div>
        <button type="button" class="btn-add-task-icon" @click="emit('create-task', 6)" title="Nova tarefa">
          <i class="fa-solid fa-plus"></i>
        </button>
      </div>

      <div class="kanban-task-list">
        <transition-group name="move" tag="div">
          <KanbanCard
            v-for="(task, tIndex) in sundayTasks"
            :key="task.id || tIndex"
            :task="task"
            @select="emit('select-task', $event)"
            @dragstart="emit('dragstart', $event, 'Domingo')"
            @dragover="emit('dragover-task', $event)"
            @drop="emit('drop-task', $event)"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>

<style scoped>
.weekend-double-column {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0px;
  height: 100%;
}

.kanban-collum-half {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 10px;
  flex: 1;
  min-height: 335px;
  background-color: #E9ECEF;
  min-width: 0;
}

.today-column {
  border: 2px solid #F1860B !important;
}

.text-primary-custom {
  color: #F1860B !important;
}

.column-header-text {
  font-size: 13px;
}

.btn-add-task-icon {
  background: transparent;
  border: none;
  color: #6C757D;
  font-size: 13px;
  cursor: pointer;
  padding: 2px;
}

.btn-add-task-icon:hover {
  color: #F1860B;
}
</style>